import React from "react";

export default class ZoomControl extends React.Component {
  render() {
    const { value = 1, onChange, onZoomIn, onZoomOut, className = "", style } = this.props;
    const min = 1;
    const max = 3;
    const pct = Math.max(0, Math.min(100, ((Number(value) - min) / (max - min)) * 100));
    return (
      <label className={`lrp-inline-label ${className}`.trim()} style={{ gap: 10, ...(style || {}) }}>
        <span style={{ fontSize: 14, opacity: .9 }}>Zoom</span>
        <button type="button" className="lrp-btn lrp-btn-ghost" onClick={onZoomOut} aria-label="Zoom out" title="Zoom out">−</button>
        <input
          className="lrp-range"
          type="range"
          min={min}
          max={max}
          step={0.05}
          value={value}
          style={{ '--lrp-range-pct': `${pct}%` }}
          onChange={(e) => onChange && onChange(e.target.value)}
          aria-label="Camera zoom"
        />
        <button type="button" className="lrp-btn lrp-btn-ghost" onClick={onZoomIn} aria-label="Zoom in" title="Zoom in">+</button>
        <span style={{ fontVariantNumeric: 'tabular-nums', minWidth: 40, textAlign: 'right' }}>{Number(value).toFixed(1)}x</span>
      </label>
    );
  }
}
